/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global Slick, exhibitorListClick */

expocadfx.ExhibitorList = function( exhData, bthData, txt) {
	'use strict';
	var comparer = expocadfx.comparer;
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var elem = expocadfx.element;
    var elemById = elem.elementById;
	var emailLink = expocadfx.emailLinkBuilder;
    var FxEvent = expocadfx.fxevent;
    var fxStyle = expocadfx.styles;
    var Grid = Slick.Grid;
	var openEmail = expocadfx.openEmail;
	var util = expocadfx.util;
    
	var doc = document;
    var exhibitors = exhData;
	var booths = bthData;
    
    var grid = null;
    var dataView = null;
    var sortCol = "name";
    var searchString = "";
	var currentSortAscending = true;
	var btnEmail = elemById( "btnExhibitorListEmail");
	var columns = null;
    
    var bgColor = (fxStyle.exhibitor.clrBg !== "") ? fxStyle.exhibitor.clrBg : fxStyle.mainHeader.clrBg;
    var txtColor = (fxStyle.exhibitor.clrText !== "") ?
        fxStyle.exhibitor.clrText : fxStyle.mainHeader.clrText;
    
    var options = {
        enableCellNavigation: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        rowHeight: 24
    };
    
    function textFormatter(row, cell, value, columnDef, dataContext) {
		var item;
		
		value = value.toString().replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
		if( dataContext) {
			item = dataView.getItem(row);
			
			if( item.priority && item.priority > 0) {
				return "<div class='cell-text premium p" + item.priority + "' >" + value + "</div>";
			}
		}
		return value;
	}

      //-------------------------------
    function tagFormatter(row, cell, value, columnDef, dataContext) {
        var chkId = "chk" + row;
		var item;
		var inputClass = "exhChk ";
		var iconClass = "icon ";
		var icon = " icon-star-outline ";
		var chk = "";
		var elem = null;
		var prem = "";

		if( dataContext) {
			item = dataView.getItem(row);
			prem = "premium p" + item.priority;
			if( item.priority && item.priority > 0) {
				inputClass += prem;
				iconClass += prem;
			}
			if( item.favorite) {
				icon = " icon-star-filled beat";
			}
			
			elem =  "<div id='" + chkId + "' class='" + inputClass + "' " + chk + " ><i class='" + iconClass + icon + "'></i>"; 
			
			if( prem !== "") {
				elem += "<i class='" + iconClass + " icon-premium" + item.priority + "'></i>";
			}
			elem += "</div>";

		}
		return elem;
    }
    
    function refreshGrid() {
        grid.invalidate();
    }
    
    function exhFilter( item, args) { 
        if( item.exhId === "" && item.bAvailable) {
            return false;
        }
        
        if (args.searchString !== "" && 
            (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
            item.location.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
            return false;
        }
        else {
            return true;
        }
    }
    
    function viewOnlyFilter( item, args) { 
        if( !item.bLocal) {
            return false;
        }
        if( item.exhId === "" && item.bAvailable) {
            return false;
        }
        
        if (args.searchString !== "" && 
            (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
            item.location.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
            return false;
        }
        else {
            return true;
        }
    }
    
    function taggedFilter( item) {
        if( item.favorite) {
            return true;
        }
        return false;
    }
		// from update local exhibitors in multi view and add or delete from sales
    function refreshDataView() {
        dataView.refresh();
		
        dataView.sort( comparer( sortCol, currentSortAscending), currentSortAscending);
        grid.invalidate();
    }
    
    function updateFilter() {
        dataView.setFilterArgs( { searchString: searchString});
        dataView.refresh();
    }
	
	function favChangeHandler( evt) {
		var booth = data.booths[ evt.data.boothIndex];
		var display = data.displayExhibitors;
		var i = 0;
		var k = 0;
		var len = 0;
		var found = false;
		var obj;
		
		if( String(booth.status) === "0") {
			return;
		}
		else {
			obj = util.arrayFind( display, "name", evt.data.exhName);
			
			if( evt.data.fav || obj.arBoothNumbers.length === 1) {
				obj.favorite = evt.data.fav;
			}
			else {
				len = data.favoriteBooths.length;
				for( i = 0; i < obj.arBoothNumbers.length; i++) {
					if( obj.arBoothNumbers[i] !== evt.data.boothNumber) {
						for( k = 0; k < len; k++) {
							if( obj.arBoothNumbers[i] === data.favoriteBooths[k].bth &&
								evt.data.exhId === data.favoriteBooths[k].exh) {
								found = true;
								break;
							}
						}
						if( found) {
							break;
						}
					}
				}
				if( !found) {
					obj.favorite = false;
				}
			}
			
			dataView.syncGridSelection( grid, false);
			refreshDataView();
		}
	}

	function isTagged( obj) {
		return obj.favorite;
	}
	
	function emailTaggedHandler() {
		var boothNums = [];
		var link = "";
		var tagged = data.displayExhibitors.filter( isTagged);
		
		tagged.forEach( function( exhibitor) {
			boothNums = boothNums.concat( exhibitor.arBoothNumbers);
		});
		
		link = emailLink( boothNums.join( ","));
		openEmail( link);
	}
	
	function enableEmailTagged() {
		btnEmail.addEventListener( "click", emailTaggedHandler);
		util.removeClass( btnEmail, "disabled");
		btnEmail.style.color = elemById( "exhibitorListHeader").style.color;
		btnEmail.style.cursor = "pointer";
	}
	
	function disableEmailTagged() {
		btnEmail.removeEventListener( "click", emailTaggedHandler);
		util.addClass( btnEmail, "disabled");
		btnEmail.style.color = config.DISABLED_GRAY;
		btnEmail.style.cursor = "auto";
	}
	
    function clickHandler( evt) {
        var cell = grid.getCellFromEvent(evt);
        var len = 0;
        var i = 0;
        var row = cell.row;
        var col = cell.cell;
        var targetRow = dataView.getItem(row);
        var ar;
        var path = "";
        var obj = null;
        var bthIndex = String( targetRow.arBoothIndexes.join(","));
        var exhName = targetRow.name;
        
        if( evt.target.tagName === "INPUT") {
            return;
        }
        //////   FAVORITES NEEDS BOOTH NUMBERS, FLOOR PLAN NEEDS BOOTH INDEX OR BOOTH OBJECTS
        // for API need exh id and name and booth number ( or numbers ??)
        if( targetRow.bLocal) {
			
            if( !config.bUseApi || 
               String( exhibitorListClick( targetRow.exhId, exhName,
                                  booths[parseInt( targetRow.arBoothIndexes[0], 10)].number)) === "1") {
                if( col === 2) {      // location cell
                    doc.dispatchEvent( new FxEvent( "Booth_Selected", { boothIndex:bthIndex}));
                }
                else if( col === 1) {
                    obj = {
                        exhibitorIndex : targetRow.exhibIndex,
                        boothIndex : bthIndex   // targetRow.arBoothIndexes.join(",")
                    };
                    doc.dispatchEvent( new FxEvent( "Exhibitor_Selected", obj));
                }
                else {
                    obj = {
                        boothNumber : targetRow.arBoothNumbers.join(","),
                        boothIndex : bthIndex,
                        exhName : exhName,
                        exhId : targetRow.exhId,
                        local : true,
                        fav : !targetRow.favorite
                    };
						// if changed on individual booths ??  Is any booth in list a fav ??
                    targetRow.favorite = !targetRow.favorite;
                    grid.invalidateRow( row);
                    grid.render();
                    
                    doc.dispatchEvent( new FxEvent( "Exhibitor_List_Fav_Change", obj));
                }
					// force list update for filtered list
				dataView.sort( comparer( sortCol, currentSortAscending), currentSortAscending);
				grid.invalidate();
				
            }
        }
        else {          //  not in this view OR no view, i.e. 'carousel' view list !!
            ar = window.location.pathname.split("?");
            path = ar[0] + "?event=" + targetRow.viewName;
            
            if( col === 2) {
                path += "&data=" + bthIndex;
                if( config.units !== "") {
                    path += "&units=" + config.units;
                }
                window.location.replace( path);
            }
            else if( col === 1) {
                    // go to view and open exhibitor info
                path += "&exh=" + exhName;
                if( config.units !== "") {
                    path += "&units=" + config.units;
                }
                window.location.replace( path);
            }
            else if( col === 0) {
                    //  find booths in Event booth list - exhibitorName && viewName
                ar = data.eventBooths;
                len = ar.length;
                
                var selectedView = targetRow.viewName;
                
                for( i = 0; i < len; i++) {
                    if( ar[i].name === exhName && ar[i].viewName === selectedView) {
                            // save or remove fav( ar[i].boothNumber, ar[i].name, bLocal)
						if( obj === null) {
							obj = {
								boothNumber : ar[i].boothNumber,
								exhName : exhName,
								exhId : ar[i].exhId,
								local : false,
								fav : !targetRow.favorite
							};
							targetRow.favorite = !targetRow.favorite;
						}
						else {
							obj.boothNumber += "," + ar[i].boothNumber;
						}
                    }
                }
				if( obj) {
					grid.invalidateRow( row);
					grid.render();
					doc.dispatchEvent( new FxEvent( "Exhibitor_List_Fav_Change", obj));
				}
            }
        }
    }

//------------------------------------------------------------------------------

    columns = [
        {id: "markBooth", name: txt.MARK_ON_DRAWING, formatter: tagFormatter, minWidth: 44, maxWidth: 56, 
            resizable: false},
        {id: "exhName", name: txt.EXHIBITOR, field: "name", sortable: true, formatter: textFormatter, cssClass: "cell-text", 
         minWidth: 150, maxWidth: 500 },
        {id: "booth", name: txt.BOOTH, field: "location", sortable: true, formatter: textFormatter, 
         cssClass: "cell-text", minWidth: 80, maxWidth: 120}
    ];
	
    dataView = new Slick.Data.DataView( {inlineFilters: false});
    dataView.beginUpdate();
    dataView.setItems(exhibitors);
    dataView.setFilterArgs( { searchString: searchString});
    if( data.filterExhibitorList) {
        dataView.setFilter( viewOnlyFilter);
    }
    else {
        dataView.setFilter( exhFilter);
    }
    dataView.endUpdate();
    
    grid = new Grid( "#exhGrid", dataView, columns, options);
    grid.setSelectionModel(new Slick.RowSelectionModel());
    
        //  tell SlickGrid to mark exhibitor name field as sorted
    grid.setSortColumn( "exhName", true);
    
    doc.getElementsByClassName("slick-header-columns")[0].style.backgroundColor = bgColor;
    doc.getElementsByClassName("slick-header-columns")[0].style.color = txtColor;
    
//  Events  -------------------------------------------------------------------------
    grid.onClick.subscribe(  clickHandler);

    
    grid.onSort.subscribe( function( e, args) {
        sortCol = args.sortCol.field;
		currentSortAscending = args.sortAsc;
		
        dataView.sort( comparer( sortCol, args.sortAsc), args.sortAsc);
    });

    dataView.onRowsChanged.subscribe( function( evt, args) {
        grid.invalidateRows( args.rows);
        grid.render();
    });

    dataView.onRowCountChanged.subscribe( function() {
        grid.updateRowCount();
        grid.render();
    });
    
    elemById( "exhibitorSearch").addEventListener( "input", function () {
        searchString = this.value;
        updateFilter();
    });
    
    if( elemById( "exhibitorFilter")) {
        elemById( "exhibitorFilter").addEventListener( "change", function( evt) {
            dataView.beginUpdate();
            if( evt.target.value === "all") {
                dataView.setFilter( exhFilter);
				disableEmailTagged();
            }
            else if( evt.target.value === "hall") {
                dataView.setFilter( viewOnlyFilter);
				disableEmailTagged();
            }
            else if( evt.target.value === "tag") {
                dataView.setFilter( taggedFilter);
				enableEmailTagged();
            }
            
            dataView.endUpdate();
            dataView.syncGridSelection( grid, false);
        });
    }
	
	doc.addEventListener( "Exhibitor_Fav_Change", favChangeHandler);
	doc.addEventListener( "Exhibitor_Info_Fav_Change", favChangeHandler);
    
 // ----------------------------------------------------------------------------------------   
    
	
    dataView.sort( comparer( sortCol, true), true);
    dataView.syncGridSelection( grid, false);
    
    return {
        refreshGrid: refreshGrid,
        refresh: refreshDataView,
        resizeCanvas : function() {grid.resizeCanvas();}
    };
};